const INTEGER = new Intl.NumberFormat("es-ES", { maximumFractionDigits: 0 });

export const formatNumber = (value) => INTEGER.format(Math.round(value));

export const formatDecimal = (value, digits = 1) =>
  new Intl.NumberFormat("es-ES", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value);

/** Value already in percent units (12.3 → "12,30%"). */
export const formatPercent = (value, digits = 2) => `${formatDecimal(value, digits)}%`;

// GA4 and Search Console send rates as a 0-1 fraction.
export const formatFraction = (fraction) => `${formatDecimal(fraction * 100, 2)} %`;

/** 90 → "1h 30m", 60 → "1h", -15 → "-15m". */
export const formatMinutes = (minutes) => {
  const absolute = Math.abs(minutes);
  const hours = Math.floor(absolute / 60);
  const mins = absolute % 60;
  const text = hours && mins ? `${hours}h ${mins}m` : hours ? `${hours}h` : `${mins}m`;
  return minutes < 0 ? `-${text}` : text;
};
